import { post } from '@classic/Foundation/Services/ApiService'
import { getNormalizedPlatformName } from '@mobi/web-native-comms/web'

let debounceTimerId = -1
let pendingKeys = [] as string[]

export function incrementQuickCounter(key: string) {
  try {
    const normalizedKey = key.replaceAll('|', '_')
    const platform = getNormalizedPlatformName()
    incrementQuickCounterImpl(`${normalizedKey}|os.${platform}`)
    incrementQuickCounterImpl(normalizedKey)
  } catch {
    // ... no-op, its only logging so silently fail on throw
  }
}

function incrementQuickCounterImpl(key: string) {
  if (debounceTimerId > 0) {
    clearTimeout(debounceTimerId)
    debounceTimerId = -1
  }

  // debounce the logging POST so that it only happens every few
  // seconds
  if (!pendingKeys.includes(key)) {
    pendingKeys.push(key)
  }

  debounceTimerId = window.setTimeout(() => postPendingKeys(), 2500)
}

async function postPendingKeys() {
  const keys = [...pendingKeys]
  pendingKeys = []

  try {
    return await post<void>({
      url: '/api/quick-count/metrics/inc',
      body: keys,
    })
  } catch {
    // ... no-op. Simply ignore errors
    return Promise.resolve()
  }
}
